import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Translation resources
const resources = {
  en: {
    translation: {
      // Common
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      refresh: 'Refresh',
      settings: 'Settings',
      actions: 'Actions',
      status: 'Status',
      total: 'Total',
      active: 'Active',
      inactive: 'Inactive',
      pending: 'Pending',
      completed: 'Completed',
      failed: 'Failed',
      name: 'Name',
      title: 'Title',
      description: 'Description',
      category: 'Category',
      categories: 'Categories',
      created: 'Created',
      updated: 'Updated',
      save: 'Save',
      cancel: 'Cancel',
      confirm: 'Confirm',
      close: 'Close',
      search: 'Search',
      filter: 'Filter',
      export: 'Export',
      import: 'Import',
      
      // Dashboard
      dashboard: 'Dashboard',
      systemDashboard: 'System Dashboard',
      adminDashboard: 'Admin Dashboard',
      partnerDashboard: 'Partner Dashboard',
      merchantDashboard: 'Merchant Dashboard',
      overview: 'Overview',
      analytics: 'Analytics',
      performance: 'Performance',
      
      // Navigation & Pages
      users: 'Users',
      partners: 'Partners',
      merchants: 'Merchants',
      devices: 'Devices',
      advertisements: 'Advertisements',
      campaigns: 'Campaigns',
      revenue: 'Revenue',
      reports: 'Reports',
      usersManagement: 'Users Management',
      partnersManagement: 'Partners Management',
      merchantsManagement: 'Merchants Management',
      devicesManagement: 'Devices Management',
      advertisementsManagement: 'Advertisements Management',
      assetsManagement: 'Assets Management',
      
      // User Management
      username: 'Username',
      email: 'Email',
      role: 'Role',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      createUser: 'Create User',
      editUser: 'Edit User',
      deleteUser: 'Delete User',
      userCreated: 'User created successfully',
      userUpdated: 'User updated successfully',
      userDeleted: 'User deleted successfully',
      
      // Partner Management
      partnerName: 'Partner Name',
      companyName: 'Company Name',
      contactPerson: 'Contact Person',
      phoneNumber: 'Phone Number',
      address: 'Address',
      createPartner: 'Create Partner',
      editPartner: 'Edit Partner',
      deletePartner: 'Delete Partner',
      
      // Merchant Management
      merchantName: 'Merchant Name',
      businessType: 'Business Type',
      location: 'Location',
      createMerchant: 'Create Merchant',
      editMerchant: 'Edit Merchant',
      deleteMerchant: 'Delete Merchant',
      
      // Device Management
      deviceName: 'Device Name',
      deviceType: 'Device Type',
      serialNumber: 'Serial Number',
      macAddress: 'MAC Address',
      ipAddress: 'IP Address',
      createDevice: 'Create Device',
      editDevice: 'Edit Device',
      deleteDevice: 'Delete Device',
      assignDevice: 'Assign Device',
      deviceRegistration: 'Device Registration',
      unassignedDevices: 'Unassigned Devices',
      availableMerchants: 'Available Merchants',
      noUnassignedDevices: 'No Unassigned Devices',
      assignToMerchant: 'Assign to Merchant',
      assignDeviceToMerchant: 'Assign Device to Merchant',
      selectMerchant: 'Select Merchant',
      assigning: 'Assigning...',
      assign: 'Assign',
      deviceDetails: 'Device Details',
      basicInformation: 'Basic Information',
      hardwareInformation: 'Hardware Information',
      locationInformation: 'Location Information',
      registeredAt: 'Registered At',
      hardware: 'Hardware',
      type: 'Type',
      device: 'Device',
      viewDetails: 'View Details',
      unauthorizedAccess: 'Unauthorized Access',
      
      // Navigation Sections
      entityManagement: 'Entity Management',
      deviceInfrastructure: 'Device & Infrastructure',
      contentCampaigns: 'Content & Campaigns',
      financialManagement: 'Financial Management',
      partnerFees: 'Partner Fees',
      businessFees: 'Business Fees',
      revenueGeneration: 'Revenue Generation',
      detailedRevenueReport: 'Detailed Revenue Report',
      
      // Demography and Location
      deviceDemography: 'Device Demography',
      geographicalDistributionOfDevices: 'Geographical Distribution of Devices',
      deviceLocations: 'Device Locations',
      totalDevices: 'Total Devices',
      activeDevices: 'Active Devices',
      pendingAssignment: 'Pending Assignment',
      provinces: 'Provinces',
      topProvinces: 'Top Provinces',
      topCities: 'Top Cities',
      deviceTypes: 'Device Types',
      deploymentEfficiency: 'Deployment Efficiency',
      geographicalCoverage: 'Geographical Coverage',
      devicesDeployedAcross: 'Devices deployed across',
      cities: 'cities',
      locationName: 'Location Name',
      zone: 'Zone',
      zones: 'Zones',
      merchant: 'Merchant',
      comprehensiveDeviceMap: 'Comprehensive Device Map',
      zoneDistribution: 'Zone Distribution',
      filterSummary: 'Filter Summary',
      showing: 'Showing',
      activeInView: 'Active in View',
      zonesInView: 'Zones in View',
      currentViewTypes: 'Current View Types',
      types: 'Types',
      
      // Advertisement Management
      adTitle: 'Advertisement Title',
      adContent: 'Advertisement Content',
      adType: 'Advertisement Type',
      startDate: 'Start Date',
      endDate: 'End Date',
      targetAudience: 'Target Audience',
      budget: 'Budget',
      createAd: 'Create Advertisement',
      editAd: 'Edit Advertisement',
      deleteAd: 'Delete Advertisement',
      publishAd: 'Publish Advertisement',
      unpublishAd: 'Unpublish Advertisement',
      
      // Metrics
      totalUsers: 'Total Users',
      totalPartners: 'Total Partners',
      totalMerchants: 'Total Merchants',
      totalRevenue: 'Total Revenue',
      totalViews: 'Total Views',
      totalTransactions: 'Total Transactions',
      activeAds: 'Active Ads',
      activeCampaigns: 'Active Campaigns',
      
      // Device Status
      online: 'Online',
      offline: 'Offline',
      maintenance: 'Maintenance',
      deviceStatus: 'Device Status',
      lastSeen: 'Last Seen',
      batteryLevel: 'Battery Level',
      signalStrength: 'Signal Strength',
      
      // Advertisement States
      draft: 'Draft',
      published: 'Published',
      rejected: 'Rejected',
      expired: 'Expired',
      paused: 'Paused',
      
      // Advertisement
      adName: 'Advertisement Name',
      views: 'Views',
      clicks: 'Clicks',
      interactions: 'Interactions',
      engagement: 'Engagement',
      duration: 'Duration',
      
      // Time periods
      today: 'Today',
      thisWeek: 'This Week',
      thisMonth: 'This Month',
      last7Days: 'Last 7 Days',
      last30Days: 'Last 30 Days',
      
      // Actions
      create: 'Create',
      edit: 'Edit',
      delete: 'Delete',
      view: 'View',
      manage: 'Manage',
      generate: 'Generate',
      add: 'Add',
      remove: 'Remove',
      update: 'Update',
      submit: 'Submit',
      reset: 'Reset',
      
      // Messages
      noDataFound: 'No data found',
      failedToLoadData: 'Failed to load data',
      dataLoadedSuccessfully: 'Data loaded successfully',
      confirmDelete: 'Are you sure you want to delete this item?',
      operationSuccessful: 'Operation completed successfully',
      operationFailed: 'Operation failed',
      
      // Table Headers
      sno: 'S.No',
      createdAt: 'Created At',
      updatedAt: 'Updated At',
      lastModified: 'Last Modified',
      
      // Auth
      login: 'Login',
      logout: 'Logout',
      signIn: 'Sign In',
      signOut: 'Sign Out',
      welcomeBack: 'Welcome back',
      profileSettings: 'Profile Settings',
    }
  },
  id: {
    translation: {
      // Common
      loading: 'Memuat...',
      error: 'Kesalahan',
      success: 'Berhasil',
      refresh: 'Segarkan',
      settings: 'Pengaturan',
      actions: 'Aksi',
      status: 'Status',
      total: 'Total',
      active: 'Aktif',
      inactive: 'Tidak Aktif',
      pending: 'Menunggu',
      completed: 'Selesai',
      failed: 'Gagal',
      name: 'Nama',
      title: 'Judul',
      description: 'Deskripsi',
      category: 'Kategori',
      categories: 'Kategori',
      created: 'Dibuat',
      updated: 'Diperbarui',
      save: 'Simpan',
      cancel: 'Batal',
      confirm: 'Konfirmasi',
      close: 'Tutup',
      search: 'Cari',
      filter: 'Filter',
      export: 'Ekspor',
      import: 'Impor',
      
      // Dashboard
      dashboard: 'Dasbor',
      systemDashboard: 'Dasbor Sistem',
      adminDashboard: 'Dasbor Admin',
      partnerDashboard: 'Dasbor Partner',
      merchantDashboard: 'Dasbor Merchant',
      overview: 'Gambaran Umum',
      analytics: 'Analitik',
      performance: 'Kinerja',
      
      // Navigation & Pages
      users: 'Pengguna',
      partners: 'Partner',
      merchants: 'Merchant',
      devices: 'Perangkat',
      advertisements: 'Iklan',
      campaigns: 'Kampanye',
      revenue: 'Pendapatan',
      reports: 'Laporan',
      usersManagement: 'Kelola Pengguna',
      partnersManagement: 'Kelola Partner',
      merchantsManagement: 'Kelola Merchant',
      devicesManagement: 'Kelola Perangkat',
      advertisementsManagement: 'Kelola Iklan',
      assetsManagement: 'Kelola Aset',
      
      // User Management
      username: 'Nama Pengguna',
      email: 'Email',
      role: 'Peran',
      password: 'Kata Sandi',
      confirmPassword: 'Konfirmasi Kata Sandi',
      createUser: 'Buat Pengguna',
      editUser: 'Edit Pengguna',
      deleteUser: 'Hapus Pengguna',
      userCreated: 'Pengguna berhasil dibuat',
      userUpdated: 'Pengguna berhasil diperbarui',
      userDeleted: 'Pengguna berhasil dihapus',
      
      // Partner Management
      partnerName: 'Nama Partner',
      companyName: 'Nama Perusahaan',
      contactPerson: 'Kontak Person',
      phoneNumber: 'Nomor Telepon',
      address: 'Alamat',
      createPartner: 'Buat Partner',
      editPartner: 'Edit Partner',
      deletePartner: 'Hapus Partner',
      
      // Merchant Management
      merchantName: 'Nama Merchant',
      businessType: 'Jenis Bisnis',
      location: 'Lokasi',
      createMerchant: 'Buat Merchant',
      editMerchant: 'Edit Merchant',
      deleteMerchant: 'Hapus Merchant',
      
      // Device Management
      deviceName: 'Nama Perangkat',
      deviceType: 'Jenis Perangkat',
      serialNumber: 'Nomor Seri',
      macAddress: 'Alamat MAC',
      ipAddress: 'Alamat IP',
      createDevice: 'Buat Perangkat',
      editDevice: 'Edit Perangkat',
      deleteDevice: 'Hapus Perangkat',
      assignDevice: 'Tugaskan Perangkat',
      deviceRegistration: 'Registrasi Perangkat',
      unassignedDevices: 'Perangkat Belum Ditugaskan',
      availableMerchants: 'Merchant Tersedia',
      noUnassignedDevices: 'Tidak Ada Perangkat Belum Ditugaskan',
      assignToMerchant: 'Tugaskan ke Merchant',
      assignDeviceToMerchant: 'Tugaskan Perangkat ke Merchant',
      selectMerchant: 'Pilih Merchant',
      assigning: 'Menugaskan...',
      assign: 'Tugaskan',
      deviceDetails: 'Detail Perangkat',
      basicInformation: 'Informasi Dasar',
      hardwareInformation: 'Informasi Hardware',
      locationInformation: 'Informasi Lokasi',
      registeredAt: 'Terdaftar Pada',
      hardware: 'Hardware',
      type: 'Jenis',
      device: 'Perangkat',
      viewDetails: 'Lihat Detail',
      unauthorizedAccess: 'Akses Tidak Diizinkan',
      
      // Navigation Sections
      entityManagement: 'Manajemen Entitas',
      deviceInfrastructure: 'Perangkat & Infrastruktur',
      contentCampaigns: 'Konten & Kampanye',
      financialManagement: 'Manajemen Keuangan',
      partnerFees: 'Biaya Partner',
      businessFees: 'Biaya Bisnis',
      revenueGeneration: 'Generasi Revenue',
      detailedRevenueReport: 'Laporan Revenue Detail',
      
      // Demography and Location
      deviceDemography: 'Demografi Perangkat',
      geographicalDistributionOfDevices: 'Distribusi Geografis Perangkat',
      deviceLocations: 'Lokasi Perangkat',
      totalDevices: 'Total Perangkat',
      activeDevices: 'Perangkat Aktif',
      pendingAssignment: 'Menunggu Penugasan',
      provinces: 'Provinsi',
      topProvinces: 'Provinsi Teratas',
      topCities: 'Kota Teratas',
      deviceTypes: 'Jenis Perangkat',
      deploymentEfficiency: 'Efisiensi Deployment',
      geographicalCoverage: 'Cakupan Geografis',
      devicesDeployedAcross: 'Perangkat tersebar di',
      cities: 'kota',
      locationName: 'Nama Lokasi',
      zone: 'Zona',
      zones: 'Zona',
      merchant: 'Merchant',
      comprehensiveDeviceMap: 'Peta Perangkat Komprehensif',
      zoneDistribution: 'Distribusi Zona',
      filterSummary: 'Ringkasan Filter',
      showing: 'Menampilkan',
      activeInView: 'Aktif dalam Tampilan',
      zonesInView: 'Zona dalam Tampilan',
      currentViewTypes: 'Jenis dalam Tampilan Saat Ini',
      types: 'Jenis',
      
      // Advertisement Management
      adTitle: 'Judul Iklan',
      adContent: 'Konten Iklan',
      adType: 'Jenis Iklan',
      startDate: 'Tanggal Mulai',
      endDate: 'Tanggal Berakhir',
      targetAudience: 'Target Audiens',
      budget: 'Anggaran',
      createAd: 'Buat Iklan',
      editAd: 'Edit Iklan',
      deleteAd: 'Hapus Iklan',
      publishAd: 'Terbitkan Iklan',
      unpublishAd: 'Batalkan Publikasi Iklan',
      
      // Metrics
      totalUsers: 'Total Pengguna',
      totalPartners: 'Total Partner',
      totalMerchants: 'Total Merchant',
      totalRevenue: 'Total Pendapatan',
      totalViews: 'Total Tayangan',
      totalTransactions: 'Total Transaksi',
      activeAds: 'Iklan Aktif',
      activeCampaigns: 'Kampanye Aktif',
      
      // Device Status
      online: 'Online',
      offline: 'Offline',
      maintenance: 'Pemeliharaan',
      deviceStatus: 'Status Perangkat',
      lastSeen: 'Terakhir Terlihat',
      batteryLevel: 'Level Baterai',
      signalStrength: 'Kekuatan Sinyal',
      
      // Advertisement States
      draft: 'Draft',
      published: 'Diterbitkan',
      rejected: 'Ditolak',
      expired: 'Kedaluwarsa',
      paused: 'Dijeda',
      
      // Advertisement
      adName: 'Nama Iklan',
      views: 'Tayangan',
      clicks: 'Klik',
      interactions: 'Interaksi',
      engagement: 'Keterlibatan',
      duration: 'Durasi',
      
      // Time periods
      today: 'Hari Ini',
      thisWeek: 'Minggu Ini',
      thisMonth: 'Bulan Ini',
      last7Days: '7 Hari Terakhir',
      last30Days: '30 Hari Terakhir',
      
      // Actions
      create: 'Buat',
      edit: 'Edit',
      delete: 'Hapus',
      view: 'Lihat',
      manage: 'Kelola',
      generate: 'Buat',
      add: 'Tambah',
      remove: 'Hapus',
      update: 'Perbarui',
      submit: 'Kirim',
      reset: 'Reset',
      
      // Messages
      noDataFound: 'Tidak ada data ditemukan',
      failedToLoadData: 'Gagal memuat data',
      dataLoadedSuccessfully: 'Data berhasil dimuat',
      confirmDelete: 'Apakah Anda yakin ingin menghapus item ini?',
      operationSuccessful: 'Operasi berhasil diselesaikan',
      operationFailed: 'Operasi gagal',
      
      // Table Headers
      sno: 'No',
      createdAt: 'Dibuat Pada',
      updatedAt: 'Diperbarui Pada',
      lastModified: 'Terakhir Dimodifikasi',
      
      // Auth
      login: 'Masuk',
      logout: 'Keluar',
      signIn: 'Masuk',
      signOut: 'Keluar',
      welcomeBack: 'Selamat datang kembali',
      profileSettings: 'Pengaturan Profil',
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // default language
    fallbackLng: 'en',
    
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
